// 판매 인사이트 API 응답 → 화면 값 매핑 (순수 함수)

// item.trend/rank_delta → TrendValue 문자열 ('🔥5' | '▲2' | '▼1' | '—')
export const trendLabel = item => {
  const delta = Math.abs(Number(item?.rank_delta) || 0);
  if (!item || item.trend === 'flat' || !delta) return '—';
  if (item.trend === 'surge') return `🔥${delta}`;
  return `${item.trend === 'down' ? '▼' : '▲'}${delta}`;
};

// 상세 머리 '전국 N위 · 전주 대비' (Figma 76:17942·76:18468 — 지역·취급률 목록에서도 전국 순위)
// 전국 목록은 목록 값, 그 외는 순위 추이 series 의 national_rank 최근 2주로 계산 (없으면 rank null)
export const nationalHero = (selected, scope, series) => {
  if (scope === 'national') return { rank: selected?.rank ?? null, item: selected ?? null };
  const last = series?.at(-1)?.national_rank;
  if (last == null) return { rank: null, item: null };
  const prev = series.at(-2)?.national_rank;
  const delta = prev != null ? prev - last : 0; // + = 순위 상승
  const trend = !delta ? 'flat' : delta >= 5 ? 'surge' : delta > 0 ? 'up' : 'down';
  return { rank: last, item: { rank_delta: Math.abs(delta), trend } };
};

// 상세 패널 순위 추이 차트 tone
export const trendTone = item =>
  item?.trend === 'down' ? 'down' : trendLabel(item) === '—' ? 'flat' : 'up';

// 재고 판정 (백엔드 10/23: 최근 60일 이 약국 판매 이력) → 'in' 재고 / 'none' 미취급 / null 표시 안 함
// 결품은 판매 이력으로 구분할 수 없어 백엔드가 내지 않음
export const stockType = item =>
  item?.my_stock_status === 'in_stock' ? 'in' : item?.my_stock_status === 'not_handled' ? 'none' : null;

// 필터 칩 (결품 칩은 판정 불가로 제외)
export const filterRanks = (items, filter) => {
  if (filter === '미취급') return items.filter(item => stockType(item) === 'none');
  if (filter === '급상승 (▲5+)')
    return items.filter(item => item.trend === 'surge' || Number(item.rank_delta) >= 5);
  if (filter === '하락') return items.filter(item => item.trend === 'down');
  return items;
};

// '2026-05-12' → '5/12'
export const shortDate = value => {
  const [, m, d] = String(value ?? '').split('-');
  return m && d ? `${Number(m)}/${Number(d)}` : '';
};

export const periodLabel = (start, end) =>
  start && end ? `${shortDate(start)} ~ ${shortDate(end)}` : '-';

// 값 배열 → 400×131 차트 polyline 좌표 (x 12~388, y 8~94). invert: 순위(작을수록 위)
// null(최소 기준 미달 주의 순위 등)은 점을 찍지 않고 x 위치만 유지
export const chartPoints = (values, invert = false) => {
  const all = (values || []).map(v => (v == null ? NaN : Number(v)));
  const nums = all.filter(Number.isFinite);
  if (!nums.length) return '';
  const min = Math.min(...nums);
  const span = Math.max(...nums) - min;
  const step = all.length > 1 ? 376 / (all.length - 1) : 0;
  return all
    .map((v, i) => {
      if (!Number.isFinite(v)) return null;
      const ratio = span ? (v - min) / span : 0.5;
      const y = 8 + 86 * (invert ? ratio : 1 - ratio);
      return `${Math.round(12 + i * step)},${Math.round(y)}`;
    })
    .filter(Boolean)
    .join(' ');
};
